/*
 *
 * Adjustments actions
 *
 */

import {
  DEFAULT_ACTION,
  SEARCH_ADJUSTMENTS,
  SAVE_ADJUSTMENTS,
  UPDATE_TABLE_DATA,
  RESET_FILTERS,
  RESET_PAGE,
  UPDATE_FILTERS,
  DISABLE_LOADER,
  ENABLE_LOADER,
  VENDOR_DATA_BY_ID,
  SAVE_VENDOR_DATA_BY_ID,
  ADJUST_BALANCE,
  EXPORT_TO_CSV,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function searchAdjustmentsAction(data) {
  return {
    type: SEARCH_ADJUSTMENTS,
    data,
  };
}

export function saveAdjustmentsAction(data) {
  return {
    type: SAVE_ADJUSTMENTS,
    data,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function resetFiltersAction() {
  return {
    type: RESET_FILTERS,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function vendorDataByIdAction(data) {
  return {
    type: VENDOR_DATA_BY_ID,
    data,
  };
}

export function saveVendorDataByIdAction(data) {
  return {
    type: SAVE_VENDOR_DATA_BY_ID,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function adjustBalanceAction(data) {
  return {
    type: ADJUST_BALANCE,
    data,
  };
}

export function exportToCSVAction(data) {
  return {
    type: EXPORT_TO_CSV,
    data,
  };
}
